import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * "+ Skapa projekt" at the top of Hem and Projekt, on phones only: the bottom
 * bar has no round create button (ClickUp 869fmfrmm). Opens the same flow as
 * the menu's "Skapa projekt".
 */
export function MobileCreateProjectButton() {
  const { t } = useTranslation();
  return (
    <Link to="/projects/create" className="btn btn-primary mobile-create-project" data-testid="mobile-create-project">
      <i className="feather-plus" aria-hidden="true"></i>
      <span>{t('appNav.createProject')}</span>
    </Link>
  );
}
